module.exports = __webpack_public_path__ + "img/img_02_bottom@2x.a05d7f7d.png";